const nfe_columns = [
    {text: 'Chave de acesso', width: '80% ', className: 'text-max-sm'},
    {text: 'N° da Nf-e', width: '10% ', className: 'text-max-sm'},
    {text: 'Pin', width: '10% ', className: 'text-max-sm'},
    {text: 'Remover', className: 'text-max-sm px-1 text-center'}
];

export default nfe_columns;
